<script setup lang="ts">

import { Backgrounds, usePresentation } from "@presentation/Types";

const presentation = usePresentation();
presentation.backgroundImage = Backgrounds.Three;

</script> 

<template>

    <div class="flex flex-col min-h-full items-center justify-center w-full h-full gap-8">
        
        <Image src="/carbucks-driven-by-presidian.png" class="w-4/5 md:w-3/5 lg:w-1/5" />

        <h1 class="text-2xl md:text-3xl lg:text-6xl font-semibold uppercase text-center">
            Thank You
        </h1>
        <h1 class="text-xl md:text-2xl lg:text-5xl font-semibold uppercase opacity-30 text-center -mt-6">
            Any Questions?
        </h1>

        <RouterLink to="/" class="-mt-4">www.carbucks.com.au</RouterLink>

    </div>

</template>